import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChatCategories from '../components/ChatCategories';

const ChatCategorySettings = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          variant="outlined"
        >
          Назад
        </Button>
        <Typography variant="h4">
          Настройки категории чатов
        </Typography>
      </Box>
      
      <ChatCategories />
    </Container>
  );
};

export default ChatCategorySettings;
